import { render, staticRenderFns } from "./AndroidHealthActivities.vue?vue&type=template&id=3cc87900&scoped=true"
import script from "./AndroidHealthActivities.vue?vue&type=script&lang=js"
export * from "./AndroidHealthActivities.vue?vue&type=script&lang=js"
import style0 from "./AndroidHealthActivities.vue?vue&type=style&index=0&id=3cc87900&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc87900",
  null
  
)

export default component.exports